import { useTranslation } from 'react-i18next'
import { Title } from 'vnetwork-ui'
import GokuDataGrid from '@/components/GokuDataGrid'
import { getResellerInvoices } from '@/modules/Reseller/services'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { columns } from './columns'
import ReceiptIcons from '@/icons/ReceiptIcons'

interface InvoicesProps {
    resellerId: number
}

const Invoices: React.FC<InvoicesProps> = ({ resellerId }) => {
    const { t } = useTranslation('reseller')

    return (
        <GokuDataGrid
            apiCall={(payload) => getResellerInvoices(resellerId, payload)}
            columns={columns(t)}
            reactQueryKey={`${QUERY_KEYS.RESELLERS}-invoices-${resellerId}`}
            dataGridProps={{
                getRowId: (row) => row?.invoice_id,
            }}
            options={{
                title: (
                    <Title
                        title={t('customer_invoices')}
                        icon={() => (
                            <ReceiptIcons className="text-bg-primary w-6 h-6" />
                        )}
                    />
                ),
                pageSize: 5,
                showSearch: false,
                showHideColumn: false,
            }}
        />
    )
}

export default Invoices
